<template>
  <button
    v-if="grade"
    type="button"
    class="grade-badge rounded-full bg-grey-lightest flex items-center justify-center"
    :class="isLarge ? 'h-15 w-15 lg:h-22.5 lg:w-22.5' : 'h-15 w-15'"
    :style="{'--grade-color': gradeColor, '--grade-percent': gradePercent}"
    title="Click to learn about our grading system"
    @click.prevent="showModal"
  >
    <div
      class="rounded-full bg-white flex items-center justify-center"
      :class="isLarge ? 'h-11 w-11 lg:h-17.5 lg:w-17.5' : 'h-11 w-11'">
      <svg-sprite
        href="icon-hiker"
        :class="isLarge ? 'h-5 w-3.75 lg:h-6 lg:w-5' : 'h-5 w-3.75'">
      </svg-sprite>
      <p
        class="font-primary font-extrabold ml-0.5"
        :class="isLarge ? 'text-20 lg:text-24' : 'text-20'"
        >
        {{ grade }}
      </p>
    </div>
  </button>
</template>

<script>
import SvgSprite from '../vendor/enso/components/SvgSprite.vue';

export default {
  components: { SvgSprite },

  props: {
    isLarge: {
      type: Boolean,
      default: false,
    },
    grade: {
      type: Number,
    },
  },

  computed: {
    gradeColor() {
      let color;

      if (this.grade < 4) {
        color = '#8fa68d';
      }
      else if (this.grade > 6) {
        color = '#83353a';
      }
      else {
        color = '#e6d058';
      };

      return color;
    },

    gradePercent() {
      return `${this.grade * 11.1111}%`;
    },
  },

  methods: {
    showModal() {
      this.$store.commit('modals/SET_GRADING_MODAL', true);
    },
  },
};
</script>
